import { FileExtension } from '../shared/schemas/FileExtension'
import { FILE_MAX_CHUNK_SIZE } from './domain/models/FileMaxChunkSize'
import { PresignUrlOptions } from './domain/models/PresignUrl'
import { UploadFileOptions, UploadProgress } from './domain/models/UploadFile'
import { FileUploadRepository } from './domain/repositories/fileUploadRepository'
import { fileUploadDatasourceAdapter } from './external/fileUploadDatasourceAdapter'
import { fileUploadRepositoryAdapter } from './infra/fileUploadRepositoryAdapter'

export const fileUploadInstance = FileUpload(
  fileUploadRepositoryAdapter(fileUploadDatasourceAdapter)
)

export function FileUpload(fileUploadRepository: FileUploadRepository) {
  return {
    async presignAndUploadFile({
      contentType,
      folderName,
      fileName,
      file,
      onUploadProgress
    }: {
      contentType: FileExtension
      folderName: string
      fileName: string
      file: File
      onUploadProgress?: UploadProgress
    }) {
      const chunkSize = FILE_MAX_CHUNK_SIZE
      const partsCount = Math.ceil(file.size / chunkSize)

      const {
        assignedUrls,
        fileName: generatedFileName,
        uploadId
      } = await fileUploadRepository.presignUrl({
        contentType,
        fileName,
        folderName,
        number: partsCount
      })

      await fileUploadRepository.uploadFile({
        file,
        generatedFileName,
        folderName,
        assignedUrls,
        uploadId,
        onUploadProgress
      })

      const url = new URL(assignedUrls[0])
      return {
        url: `${url.origin}${url.pathname}`,
        fileName: generatedFileName
      }
    },

    async uploadFile({
      folderName,
      generatedFileName,
      file,
      onUploadProgress,
      assignedUrls,
      uploadId,
      numberOfParts
    }: UploadFileOptions) {
      return await fileUploadRepository.uploadFile({
        folderName,
        generatedFileName,
        file,
        onUploadProgress,
        assignedUrls,
        uploadId,
        numberOfParts
      })
    },

    async presignUrl({
      contentType,
      folderName,
      fileName,
      number
    }: PresignUrlOptions) {
      return await fileUploadRepository.presignUrl({
        contentType,
        folderName,
        fileName,
        number
      })
    }
  }
}
